import React from 'react';
import ModalList from '../../common/Modal/ModalList';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Gantt Chart for Trello</h1>
			<div className='project-popup__description '>
				GoodGantt is a planning tool for Trello, developed to simplify the project
				planning process. It includes a large number of different features and allows
				the project manager and his team to carry out the project planning in
				real-time. <br />I joined this project almost at the beginning and did many
				optimizations in the existing code, and developed a large part of GoodGantt
				functionality. <br />
				In addition to the core Gantt Chart functionality, I implemented the
				monetization part of the application:
				<ModalList disc>
					<li>Tariff plans functionality</li>
					<li>
						Teams functionality (The project manager can pay for places in his team
						and add different users to the team. Only the users will get access to
						Gantt App).
					</li>
					<li>Billing history page</li>
					<li>Promo functionality</li>
					<li>
						Custom integration with a payment system (Custom designed widget, email
						cheques, recurrent payments).
					</li>
				</ModalList>
			</div>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						React.js, Redux, Firebase, Node.js + express, MongoDB, Web-sockets,
						RabbitMQ, Payture payment system, Trello API
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/HhPNp9aiElg'
					title='GoodGantt - Multifunctional Chrome extension for Trello'
				/>
			</div>
			<div className='project-popup__buttons '>
				<a
					href='https://goodgantt.com/ '
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Visit project
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
